import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean; // Add the error property
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, placeholder, error, ...props }, ref) => {
    // Generate a unique id if none is provided
    const inputId = React.useId()
    return (
      <div className="relative">
        <input
          id={inputId}
          type={type}
          placeholder=" "
          className={cn(
            error && "!border-[#d91c5b] text-![#d91c5b]",
            "peer flex h-[42px]  w-full border border-[#bababa] !rounded-none !overflow-hidden !border-solid bg-background !p-[0.5rem] text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 outline-2 outline-solid outline-transparent outline-offset-2 focus:border-[#0a9ca4] hover:border-[#0a9ca4]",
            (props.value || (ref && "current" in ref && ref.current?.value)) && "border-[#0a9ca4]",
            className
          )}
          ref={ref}
          {...props}
        />
        <label
          htmlFor={inputId}
          className={cn(
            "absolute cursor-auto pointer-events-none  left-2.5 top-2 w-full pr-8 text-[#BABABA] text-md transition-all duration-300 ease-linear transform translate-x-0 translate-y-0   rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100  peer-focus:origin-left peer-focus:translate-y-[-1.7rem] peer-focus:scale-x-75 peer-focus:scale-y-75  peer-focus:scale-75 peer-focus:bg-secondary peer-focus:pl-2 peer-focus:pr-2 peer-focus:text-[#0a9ca4] overflow-hidden text-ellipsis whitespace-nowrap max-w-fit",
            (props.value || (ref && "current" in ref && ref.current?.value))  && "!origin-left !translate-y-[-1.7rem] !scale-x-75 !scale-y-75   bg-secondary !pl-2 !pr-2 text-[#0a9ca4]",
            error && "!text-[#d91c5b]"
          )}
        >
          {placeholder}
        </label>
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
